<template>
  <vs-tabs :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="profile-tabs" :key="isSmallerScreen" :value="active_step">

    <!-- GENERAL -->
    <vs-tab icon-pack="feather" icon="icon-user" :label="!isSmallerScreen ? 'General' : ''">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <user-settings-general />
      </div>
    </vs-tab>

  <vs-tab icon-pack="feather" icon="icon-lock" :label="!isSmallerScreen ? 'Manage Password' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <user-settings-change-password />
      </div>
    </vs-tab>

    <vs-tab icon-pack="feather" icon="icon-bell" :label="!isSmallerScreen ? 'Manage Notifications' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <NotificationManager/>
      </div>
    </vs-tab>

    <vs-tab v-if="is_leave_enabled" icon-pack="feather" icon="icon-moon" :label="!isSmallerScreen ? 'Manage Leave' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <ManageMyLeaves/>
      </div>
    </vs-tab>

    <vs-tab icon-pack="feather" icon="icon-database" :label="!isSmallerScreen ? 'Training & Qualifications' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <MySkillQualificationHome/>
      </div>
    </vs-tab>

    <vs-tab icon-pack="feather" icon="icon-smartphone" :label="!isSmallerScreen ? 'Mobile App Security' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <MobileAppSecurity/>
      </div>
    </vs-tab>

  </vs-tabs>
</template>
<script>
import UserSettingsGeneral from './UserSettingsGeneral'
import UserSettingsChangePassword from './UserSettingsChangePassword'
import NotificationManager from './NotificationManager.vue'
import ManageMyLeaves from './manage-leaves/ManageMyLeaves.vue'
import MySkillQualificationHome from './training-qualifications/MySkillQualificationHome.vue'
import MobileAppSecurity from './MobileAppSecurity.vue'

export default {
    components: {
        UserSettingsGeneral,
        UserSettingsChangePassword,
        NotificationManager,
        ManageMyLeaves,
        MySkillQualificationHome,
        MobileAppSecurity
    },
    data () {
        return {
          active_step: this.$route.query.step ? this.$route.query.step : '0'
        }
    },
    mounted() {
      
    },
    computed: {
        isSmallerScreen () {
            return this.$store.state.windowWidth < 768
        },
        is_leave_enabled() {
          return this.$store.getters.currentUser.is_leave_enabled || false
        }
    }
}
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
